var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocument = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 38,
    viewBox: "0 0 30 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 33.25V10.6875L18.5625 0H5.5C4.24022 0 3.03204 0.500445 2.14124 1.39124C1.25044 2.28204 0.75 3.49022 0.75 4.75V33.25C0.75 34.5098 1.25044 35.718 2.14124 36.6088C3.03204 37.4996 4.24022 38 5.5 38H24.5C25.7598 38 26.968 37.4996 27.8588 36.6088C28.7496 35.718 29.25 34.5098 29.25 33.25ZM18.5625 7.125C18.5625 8.06983 18.9378 8.97597 19.6059 9.64407C20.274 10.3122 21.1802 10.6875 22.125 10.6875H26.875V33.25C26.875 33.8799 26.6248 34.484 26.1794 34.9294C25.734 35.3748 25.1299 35.625 24.5 35.625H5.5C4.87011 35.625 4.26602 35.3748 3.82062 34.9294C3.37522 34.484 3.125 33.8799 3.125 33.25V4.75C3.125 4.12011 3.37522 3.51602 3.82062 3.07062C4.26602 2.62522 4.87011 2.375 5.5 2.375H18.5625V7.125Z",
    fill: "#3B3B3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 14.25H15.25",
    stroke: "#3B3B3B",
    strokeWidth: 2.375,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 21.375H22.375",
    stroke: "#3B3B3B",
    strokeWidth: 2.375,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 28.5H22.375",
    stroke: "#3B3B3B",
    strokeWidth: 2.375,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocument);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/document.6109cee59a8405ccdf70b34c2ee3fea6.svg";